import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const useTabsWithParams = ({ withParams = false, tab, setTab, initTab }) => {

    const [searchParam, setSearchParam] = useSearchParams();

    useEffect(() => {
        if (!withParams || !tab)
            return;

        const currentParams = Object.fromEntries(searchParam.entries());
        setSearchParam({ ...currentParams, tab });
    }, [tab])

    useEffect(() => {
        if (!withParams)
            return;

        setTab(!!searchParam.get('tab') && searchParam.get('tab') !== "undefined"
            ? searchParam.get('tab')
            : initTab);
    }, [])

    return {};
}

export default useTabsWithParams;